import { c as _c } from "react/compiler-runtime";
import { EmptyState } from '@onefootprint/ui';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { ONBOARDINGS_ID } from '@/entity/components/content/components/onboardings-shared/constants';
type NoGraphEmptyStateProps = {
  fpId: string;
  onboardingId: string;
  entityKind: 'user' | 'business';
};
const NoGraphEmptyState = t0 => {
  const $ = _c(17);
  const {
    fpId,
    onboardingId,
    entityKind
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardingTraceDialog.noGraph"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const router = useRouter();
  const urlPath = entityKind === "business" ? "businesses" : "users";
  const detailsHref = `/${urlPath}/${fpId}?onboarding_id=${onboardingId}#${ONBOARDINGS_ID}`;
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp3);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== detailsHref || $[8] !== router) {
    t5 = () => router.push(detailsHref);
    $[7] = detailsHref;
    $[8] = router;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = {
      label: t4,
      onClick: t5
    };
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t6) {
    t7 = <div className="flex items-center justify-center h-full p-6 md:p-10"><div className="max-w-[440px]"><EmptyState testID="onboarding-trace-no-graph" title={t2} description={t3} cta={t6} /></div></div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default NoGraphEmptyState;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.description;
}
function _temp3($_1) {
  return $_1.cta;
}